import React, { useState, useEffect, useRef } from 'react';
import { Button, Form, Row, Col, Modal, Badge, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { get_AstroData, get_AstrologerSingleData } from '../../../store/actions/CommanAction';
import { setAstroId } from '../../../store/Action_Types';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import user from './../../../images/task/user.jpg';
import Loader from '../Loader/Loader';
import * as XLSX from 'xlsx';

const AstrologerBlocklist = () => {
  const dispatch = useDispatch();
  const effectRan = useRef(false);
  const AstroData = useSelector((state) => state.feedBackReducer.AstroData);

  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    name: '',
    mobile: '',
    blockReason: '',
    blockDate: ''
  });
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  const [selectedAstro, setSelectedAstro] = useState(null);
  const [unblockReason, setUnblockReason] = useState('');
  const [blockedAstroData, setBlockedAstroData] = useState([]);
  const [showBlockDetailsModal, setShowBlockDetailsModal] = useState(false);
  const [selectedBlockDetails, setSelectedBlockDetails] = useState(null);

  const itemsPerPage = 10;

  useEffect(() => {
    if (!effectRan.current) {
      fetchBlockedAstrologers();
      effectRan.current = true;
    }
  }, []);

  const fetchBlockedAstrologers = async () => {
    setLoading(true);
    try {

      await dispatch(get_AstroData("1"));
    } catch (error) {
      console.error('Error fetching blocked astrologers:', error);
      swal('Error', 'Failed to fetch blocked astrologers', 'error');
    } finally {
      setLoading(false);
    }
  };


  const getBlockedAstrologers = () => {
    return AstroData?.filter(astro => astro.IsBlock === true || astro.IsBlock === 1) || [];
  };

  const filteredBlockedData = getBlockedAstrologers()?.filter((item) => {
    const query = searchQuery.toLowerCase();
    return (
      item.DisplayName?.toLowerCase().includes(query) ||
      item.EMPID?.toLowerCase().includes(query) ||
      item.RegMobileNo?.toLowerCase().includes(query) ||
      item.EmailID?.toLowerCase().includes(query) ||
      item.BlockReason?.toLowerCase().includes(query)
    );
  });

  const getFilteredAndSortedData = () => {
    let filteredData = getBlockedAstrologers() || [];

    if (filters.name) {
      filteredData = filteredData.filter(item =>
        item.DisplayName?.toLowerCase().includes(filters.name.toLowerCase())
      );
    }
    if (filters.mobile) {
      filteredData = filteredData.filter(item =>
        item.RegMobileNo?.includes(filters.mobile)
      );
    }
    if (filters.blockReason) {
      filteredData = filteredData.filter(item =>
        item.BlockReason?.toLowerCase().includes(filters.blockReason.toLowerCase())
      );
    }

    if (sortField) {
      filteredData.sort((a, b) => {
        const aValue = a[sortField];
        const bValue = b[sortField];

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return sortOrder === 'asc'
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }

        return sortOrder === 'asc'
          ? (aValue > bValue ? 1 : -1)
          : (aValue < bValue ? 1 : -1);
      });
    }

    return filteredData;
  };

  const handleUnblockAstrologer = async () => {
    if (!selectedAstro) return;

    try {
      const postData = {
        AstroId: selectedAstro.ID,
        IsBlock: false,
        BlockReason: unblockReason || 'Unblocked by admin'
      };

      await AddUpdate('Astrologer/UpdateAstrologerBlock', postData);


      await fetchBlockedAstrologers();

      swal('Success', 'Astrologer has been unblocked successfully!', 'success');
      setShowUnblockModal(false);
      setSelectedAstro(null);
      setUnblockReason('');
    } catch (error) {
      console.error('Error unblocking astrologer:', error);
      swal('Error', 'Failed to unblock astrologer', 'error');
    }
  };

  const handleViewBlockDetails = (astro) => {
    setSelectedBlockDetails(astro);
    setShowBlockDetailsModal(true);
  };

  const exportToExcel = () => {
    const dataToExport = getFilteredAndSortedData().map(astro => ({
      'Name': astro.DisplayName || 'N/A',
      'Mobile': astro.RegMobileNo || 'N/A',
      'Email': astro.EmailID || 'N/A',
      'Gender': astro.Gender || 'N/A',
      'Rating': astro.Rating || '0',
      'Total Orders': astro.TotalOrders || '0',
      'Followers': astro.Followers || '0',
      'Block Reason': astro.BlockReason || 'N/A',
      'Block Date': astro.BlockDate || 'N/A'
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Blocked Astrologers');
    XLSX.writeFile(workbook, 'Blocked_Astrologers_List.xlsx');
  };

  const handleResetFilters = () => {
    setFilters({ name: '', mobile: '', blockReason: '', blockDate: '' });
    setSortField('');
    setSortOrder('asc');
    setCurrentPage(1);
  };

  const columns = [
    {
      name: 'Image',
      selector: row => row.AvatarUrl,
      cell: row => (
        <img
          src={row.AvatarUrl ? `https://${row.AvatarUrl.replace(/\\/g, "/")}` : user}
          alt={row.DisplayName || 'Astrologer'}
          className="rounded-circle"
          style={{ width: '40px', height: '40px', objectFit: 'cover', border: '1px solid #ddd' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = user;
          }}
        />
      ),
      width: '80px'
    },
    {
      name: 'Name',
      selector: row => row.DisplayName,
      sortable: true,
      cell: row => (
        <div>
          <div className="fw-bold">{row.DisplayName || 'N/A'}</div>
          <small className="text-muted">ID: {row.EMPID || 'N/A'}</small>
        </div>
      )
    },
    {
      name: 'Contact',
      selector: row => row.RegMobileNo,
      sortable: true,
      cell: row => (
        <div>
          <div>{row.RegMobileNo || 'N/A'}</div>
          <small className="text-muted">{row.EmailID || 'N/A'}</small>
        </div>
      )
    },
    {
      name: 'Rating & Orders',
      selector: row => row.Rating,
      sortable: true,
      cell: row => (
        <div>
          <div className="d-flex align-items-center">
            <span className="text-warning me-1">★</span>
            <span>{row.Rating || '0'}</span>
          </div>
          <small className="text-muted">{row.TotalOrders || '0'} orders</small>
        </div>
      )
    },
    {
      name: 'Block Reason',
      selector: row => row.BlockReason,
      sortable: true,
      cell: row => (
        <div>
          <Badge bg="danger" className="mb-1">
            Blocked
          </Badge>
          <div className="small text-truncate" style={{ maxWidth: '150px' }}>
            {row.BlockReason || 'No reason provided'}
          </div>
        </div>
      )
    },
    {
      name: 'Block Date',
      selector: row => row.BlockDate,
      sortable: true,
      cell: row => (
        <div>
          {row.BlockDate ? moment(row.BlockDate).format('DD/MM/YYYY') : 'N/A'}
          <br />
          <small className="text-muted">
            {row.BlockDate ? moment(row.BlockDate).fromNow() : ''}
          </small>
        </div>
      )
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-1">
          <Button
            variant="outline-info"
            size="sm"
            onClick={() => handleViewBlockDetails(row)}
            title="View Details"
          >
            <i className="bi bi-eye"></i>
          </Button>
          <Button
            variant="outline-success"
            size="sm"
            onClick={() => {
              setSelectedAstro(row);
              setShowUnblockModal(true);
            }}
            title="Unblock"
          >
            <i className="bi bi-unlock"></i>
          </Button>
        </div>
      ),
      width: '120px'
    }
  ];

  if (loading) {
    return <Loader />;
  }

  const blockedCount = getBlockedAstrologers().length;

  return (
    <>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">

          <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Astrologers Blocklist</h2>
          <div className="d-flex align-items-center gap-2">
            <span className="badge bg-danger fs-6 p-2 ">
              {blockedCount} Blocked
            </span>
            <Button variant="outline-primary" size="sm" onClick={exportToExcel}>
              <i className="bi bi-download me-1"></i>
              Export
            </Button>
          </div>

        </div>

        <div className="card-body">

          <Row className="mb-3">
            <Col xs={12} md={3}>
              <div className="form-group">
                <Form.Group controlId="searchName">
                  <Form.Control
                    type="text"
                    placeholder="Search Name/ID"
                    value={filters.name}
                    onChange={(e) => setFilters(prev => ({ ...prev, name: e.target.value }))}
                    size="sm"
                  />
                </Form.Group>
              </div>

            </Col>
            <Col xs={12} md={3}>
              <div className="form-group">
                <Form.Group controlId="searchMobile">
                  <Form.Control
                    type="text"
                    placeholder="Search Mobile"
                    value={filters.mobile}
                    onChange={(e) => setFilters(prev => ({ ...prev, mobile: e.target.value }))}
                    size="sm"
                  />
                </Form.Group>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="form-group">
                <Form.Group controlId="searchBlockReason">
                  <Form.Control
                    type="text"
                    placeholder="Search Block Reason"
                    value={filters.blockReason}
                    onChange={(e) => setFilters(prev => ({ ...prev, blockReason: e.target.value }))}
                    size="sm"
                  />
                </Form.Group>
              </div>
            </Col>
            <Col xs={12} md={3} className="d-flex ">
              <Row className="w-100 g-2">
                <Col xs={6}>
                  <Button
                    variant="warning"
                    className="w-100"
                    onClick={handleResetFilters}
                    size="sm"
                  >
                    Reset
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={fetchBlockedAstrologers}
                    size="sm"
                  >
                    Refresh
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Data Table */}
          <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '70vh' }}>
            <DataTable
              columns={columns}
              data={getFilteredAndSortedData()}
              pagination
              paginationPerPage={itemsPerPage}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              highlightOnHover
              pointerOnHover
              customStyles={customStyles}
              noHeader
              defaultSortFieldId={1}
              defaultSortAsc={true}
              persistTableHead
              responsive
              fixedHeader
              fixedHeaderScrollHeight="60vh"
              noDataComponent={
                <div className="text-center py-4">
                  <i className="bi bi-shield-check text-success fs-1"></i>
                  <p className="mt-2">No blocked astrologers found</p>
                </div>
              }
            />
          </div>
        </div>
      </div>


      <Modal show={showUnblockModal} onHide={() => setShowUnblockModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-unlock text-success me-2"></i>
            Unblock Astrologer
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAstro && (
            <div className="mb-3">
              <h6>Astrologer Details:</h6>
              <p><strong>Name:</strong> {selectedAstro.DisplayName}</p>
              <p><strong>Mobile:</strong> {selectedAstro.RegMobileNo}</p>
              <p><strong>Current Block Reason:</strong> {selectedAstro.BlockReason || 'No reason provided'}</p>
            </div>
          )}
          <Form.Group>
            <Form.Label>Unblock Reason (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter reason for unblocking..."
              value={unblockReason}
              onChange={(e) => setUnblockReason(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUnblockModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleUnblockAstrologer}>
            <i className="bi bi-unlock me-1"></i>
            Unblock
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={showBlockDetailsModal} onHide={() => setShowBlockDetailsModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-info-circle text-info me-2"></i>
            Block Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBlockDetails && (
            <div className="row">
              <div className="col-md-4 text-center">
                <img
                  src={selectedBlockDetails.AvatarUrl ? `https://${selectedBlockDetails.AvatarUrl.replace(/\\/g, "/")}` : user}
                  alt={selectedBlockDetails.DisplayName}
                  className="rounded-circle mb-3"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = user;
                  }}
                />
                <h5>{selectedBlockDetails.DisplayName}</h5>
                <Badge bg="danger">Blocked</Badge>
              </div>
              <div className="col-md-8">
                <Row>
                  <Col md={6}>
                    <p><strong>Employee ID:</strong> {selectedBlockDetails.EMPID}</p>
                    <p><strong>Mobile:</strong> {selectedBlockDetails.RegMobileNo}</p>
                    <p><strong>Email:</strong> {selectedBlockDetails.EmailID}</p>
                    <p><strong>Gender:</strong> {selectedBlockDetails.Gender}</p>
                  </Col>
                  <Col md={6}>
                    <p><strong>Rating:</strong> ⭐ {selectedBlockDetails.Rating || '0'}</p>
                    <p><strong>Total Orders:</strong> {selectedBlockDetails.TotalOrders || '0'}</p>
                    <p><strong>Followers:</strong> {selectedBlockDetails.Followers || '0'}</p>
                    <p><strong>Skills:</strong> {selectedBlockDetails.Skill || 'N/A'}</p>
                  </Col>
                </Row>
                <hr />
                <div>
                  <h6>Block Information:</h6>
                  <p><strong>Block Reason:</strong> {selectedBlockDetails.BlockReason || 'No reason provided'}</p>
                  <p><strong>Block Date:</strong> {selectedBlockDetails.BlockDate ? moment(selectedBlockDetails.BlockDate).format('DD/MM/YYYY HH:mm') : 'N/A'}</p>
                  <p><strong>Blocked Since:</strong> {selectedBlockDetails.BlockDate ? moment(selectedBlockDetails.BlockDate).fromNow() : 'N/A'}</p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBlockDetailsModal(false)}>
            Close
          </Button>
          {selectedBlockDetails && (
            <Button
              variant="success"
              onClick={() => {
                setShowBlockDetailsModal(false);
                setSelectedAstro(selectedBlockDetails);
                setShowUnblockModal(true);
              }}
            >
              <i className="bi bi-unlock me-1"></i>
              Unblock
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AstrologerBlocklist; 